import { render, staticRenderFns } from "./PaymentStep.vue?vue&type=template&id=286d68d8&scoped=true&lang=pug&"
import script from "./PaymentStep.vue?vue&type=script&lang=js&"
export * from "./PaymentStep.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStep.vue?vue&type=style&index=0&id=286d68d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286d68d8",
  null
  
)

export default component.exports